import React, { useState} from "react";
import { Keyboard, StyleSheet, Platform, TouchableOpacity, StatusBar,  KeyboardAvoidingView, Switch, ImageBackground, LayoutAnimation, ScrollView, Alert, Text } from 'react-native';


import { View } from '../../../components/Themed';
import TextInputEx from '../C_Text/TextInputEx';
import TextInputExPwd from '../C_Text/TextInputExPwd';
import ModalEx from "../C_Popups/ModalEx";
import { FontAwesome, } from '@expo/vector-icons';
import * as StoreReview from 'expo-store-review';

import Utilities from '../~Utilities/Utilities';
import {ReturnTypes, UTheme, AppMain, LoginParams, FontInfo, } from '../~Utilities/Constants';
import {StringTable} from '../StringTable';
import {Connection, ConnectionOrd, ConnectionRMS, ConnectionMkt, ConnectionHis, ConnectionSys} from '../~Utilities/Connection';

import { SafeAreaView, } from 'react-native-safe-area-context';
import ReOrderEx from '../C_Popups/ReOrderEx';
import SymbolList from './SymbolList';
import TextForRef from "../C_Text/TextForRef";
import RNPickerSelect from "react-native-picker-select";
import Popup from "../C_Popups/Popup";
import MessageRates from "../C_General/MessageRates";
import OB from "./OB";
import Search from "../C_Popups/Search";
import About from "../C_Popups/About";

// import Svg, { G, Path } from 'react-native-svg';
import SvgDarkMode from "../C_General/ImagesSvg";
import { AppState } from "react-native";
import { AppStateStatus } from "react-native";
import SwitchNE from '../C_Text/SwitchNoError';

import {AES} from 'crypto-es/lib/aes.js';
import {Utf8} from 'crypto-es/lib/core.js';
import { GwyData } from "../~Utilities/Data";

/*   ---------------------------------------------------------------------   */

// var CryptoJS = require("crypto-js");

/*   ---------------------------------------------------------------------   */

// var iSystemIndex = 0;
// var oSystems=[
//               { label: "Rithmic Paper Trading", value:"Rithmic Paper Trading", system:"Rithmic Paper Trading", url: "wss://rprotocol.rithmic.com:443" },
//               { label: "Rithmic Paper Trading (beta)", value:"Rithmic Paper Trading (beta)", system:"Rithmic Paper Trading", url: "wss://rprotocol-beta.rithmic.com:443"},
//               { label: "Rithmic Dev", value:"Rithmic Dev", system:"Rithmic Dev", url: "ws://rittz00100.rithmic.com:40056"},
//              ];

// const values = [
//   'option 1',
//   'option 2',
//   'option 3',
//   'option 4',
//   'option 5'
// ];

//const sDeviceName = Device.deviceName? Device.deviceName : "Web";

/*   ---------------------------------------------------------------------   */

// var oLookBack    = Lookback.Day;
// var oLookBackAlt = Lookback.Day;

/*   ---------------------------------------------------------------------   */

var oSettAlt     : Array<any>  | null;
var oLoginParams : LoginParams | null;

/*   ---------------------------------------------------------------------   */

let  iUpdate         = 0;
let  bUpdate         = false;

// let  bGwySet         = false;

/*   ---------------------------------------------------------------------   */

let   bTimer         = false;
let   bEco           = false;
let   iFreq          = bEco? 1000 : 333; //millisecond
let   iTick_Count    = parseInt((1000/iFreq).toFixed());
let   oTimer;   
   
let   iSecs          = 0;
let   iSecs2         = 0;

let   iBat_Start     = -2;
let   iBatt          = 0;

//let   iMsg           = 0;

let   iTick          = 0;

let   bLoginPressed  = false;

let   oTmOut : NodeJS.Timeout | undefined = undefined;

//let   sLogin_State   = "Sign In";

var oOnUpdateData: (() => void);

/*   ---------------------------------------------------------------------   */

// var sSytem = "Rithmic Paper Trading";

/*   ---------------------------------------------------------------------   */

// async function AsyncSetData(sKey: string, sValue: string)
// {
//   try 
//   {
//     await AsyncStorage.setItem(StringTable.APP_NAME + ":" + sKey, sValue);
//     //alert("Saved: " + sValue);
//   } 
//   catch (error) 
//   {

//   }
// }

// /*   ---------------------------------------------------------------------   */

// async function AsyncGetData(sKey : string, oRet : (x)=>void)
//  {
//   try 
//    {
//     const value = await AsyncStorage.getItem(StringTable.APP_NAME + ":" + sKey);
//     oRet(value);
//    }
//   catch (error) 
//     {
//     oRet(null);
//     }
//   }

// /*   ---------------------------------------------------------------------   */  

// function SvgComponent(props) {
//   return (
//     <Svg width='100%' height='100%'>
//       <G  scale={.95}>
//         <Path stroke={props.color} fill={props.color} strokeWidth={0} d="M17.75,4.09L15.22,6.03L16.13,9.09L13.5,7.28L10.87,9.09L11.78,6.03L9.25,4.09L12.44,4L13.5,1L14.56,4L17.75,4.09M21.25,11L19.61,12.25L20.2,14.23L18.5,13.06L16.8,14.23L17.39,12.25L15.75,11L17.81,10.95L18.5,9L19.19,10.95L21.25,11M18.97,15.95C19.8,15.87 20.69,17.05 20.16,17.8C19.84,18.25 19.5,18.67 19.08,19.07C15.17,23 8.84,23 4.94,19.07C1.03,15.17 1.03,8.83 4.94,4.93C5.34,4.53 5.76,4.17 6.21,3.85C6.96,3.32 8.14,4.21 8.06,5.04C7.79,7.9 8.75,10.87 10.95,13.06C13.14,15.26 16.1,16.22 18.97,15.95M17.33,17.97C14.5,17.81 11.7,16.64 9.53,14.5C7.36,12.31 6.2,9.5 6.04,6.68C3.23,9.82 3.34,14.64 6.35,17.66C9.37,20.67 14.19,20.78 17.33,17.97Z"/>
//       </G>
//     </Svg>
//   );
// }

// function SvgComponent(props) {
//   return (
//     <Svg width="0%" height="70%">
//       <G {...props}>
//         <Path strokeWidth={1} stroke='yellow' fill='yellow' d="M17.75,4.09L15.22,6.03L16.13,9.09L13.5,7.28L10.87,9.09L11.78,6.03L9.25,4.09L12.44,4L13.5,1L14.56,4L17.75,4.09M21.25,11L19.61,12.25L20.2,14.23L18.5,13.06L16.8,14.23L17.39,12.25L15.75,11L17.81,10.95L18.5,9L19.19,10.95L21.25,11M18.97,15.95C19.8,15.87 20.69,17.05 20.16,17.8C19.84,18.25 19.5,18.67 19.08,19.07C15.17,23 8.84,23 4.94,19.07C1.03,15.17 1.03,8.83 4.94,4.93C5.34,4.53 5.76,4.17 6.21,3.85C6.96,3.32 8.14,4.21 8.06,5.04C7.79,7.9 8.75,10.87 10.95,13.06C13.14,15.26 16.1,16.22 18.97,15.95M17.33,17.97C14.5,17.81 11.7,16.64 9.53,14.5C7.36,12.31 6.2,9.5 6.04,6.68C3.23,9.82 3.34,14.64 6.35,17.66C9.37,20.67 14.19,20.78 17.33,17.97Z"/>
//       </G>
//     </Svg>
//   );
// }

function stopTimer()
{
  if (bTimer == true || oTimer != undefined)
    {
    clearInterval(oTimer);

    if (__DEV__)
      Utilities.Sendlog("Stopped timer");

    bTimer = false;
    oTimer = undefined;
    }
}

/*   ---------------------------------------------------------------------   */

function OnTime()
{
  iSecs++;

  if (iSecs > 5 * iTick_Count)
    {
    iSecs = 0;

    //Utilities.Sendlog("sending hb...");
    ConnectionOrd.oConn?.SendHb();
    ConnectionMkt.oConn?.SendHb();
    ConnectionHis.oConn?.SendHb();
    ConnectionRMS.oConn?.SendHb();

    }

  if (bTimer == true)
    oOnUpdateData();
}

/*   ---------------------------------------------------------------------   */

function startTimer(oUpdateData)
{
if (bTimer == true || oTimer != undefined)
  stopTimer();

/*   ---------------------------------------------------------------------   */

if (bTimer == false)
  {
  oTimer = setInterval(OnTime, iFreq);

  if (__DEV__)
    {
    Utilities.Sendlog("Running version " + StringTable.APP_VERSION + " on " + Connection.DEVICE_NAME + "...");
    Utilities.Sendlog("Started timer, freq: " + iFreq);
    }

  bTimer = true;


  iTick  = 0;
  iSecs  = 0;
  iSecs2 = 0;
  }

oOnUpdateData = oUpdateData;
}

/*   ---------------------------------------------------------------------   */

let m_event      : Array<(() => void)> = [  ];

/*   =====================================================================   */

// class TxtOp
// {
// public UpdateError : (x : number)=>void; //0: good, 1:bad, 2:duplicate
// public GetText     : ()=>string;
// public Ref         : TextInputEx;

// constructor(UpdateError, GetText, Ref)
// {
// //this.UpdateError = UpdateError;
// //this.GetText     = GetText;
// this.Ref         = Ref;  
// }
// }

// var oTxtSearch : TxtOp;
// var oTxtUsr    : TxtOp
// var oTxtPwd    : TxtOp;

/*   =====================================================================   */

var oThemes =
[
  {theme:UTheme.Blue, status:1, top:'transparent', bg:'', color:'lightgrey', file:require('../../../assets/images/t_blue_dark3.jpg')},
  {theme:UTheme.Green, status:0, top:'transparent', bg:'palegreen', color:'darkgrey', file:require('../../../assets/images/t_green_dark.jpg')},
  {theme:UTheme.Gray, status:1, top:'transparent', bg:'#36454f', color:'gray', file:require('../../../assets/images/t_gray.jpg')},
  {theme:UTheme.Metal, status:1, top:'transparent', bg:'lightgray', color:'white', file:require('../../../assets/images/t_metal.jpg')},
  {theme:UTheme.Multi, status:1, top:'transparent', bg:'lightgray', color:'white', file:require('../../../assets/images/t_multi.jpg')},

]  

/*   ---------------------------------------------------------------------   */

ConnectionSys.AddDefaults();

/*   ---------------------------------------------------------------------   */

var bInactiveEntered = false;

AppState.addEventListener('change', 
                          (e : AppStateStatus)=>
                            { 
                            if (__DEV__)                              
                              Utilities.Sendlog("App state changed: " + e);
                            
                            if (e != 'active')
                              {
                              bInactiveEntered = true;
                              }
                            else
                              {
                              bInactiveEntered = false;
                              }
                            })

/*   ---------------------------------------------------------------------   */

var sUser     = "";
var sToken    = "";
var sSvSystem = "Rithmic Paper Trading";
var iSvGwy    = 0;
var sSvGwy    : string | undefined = undefined;

/*   -------------------------------------------------------------------   */

ConnectionOrd.
GetDataLocal("login", (x)=> 
    {
    if (x == null) 
      return;
  
    let val : ILogin = JSON.parse(x);
    sUser            = val.user;
    //bEco       = val.eco;

    if (__DEV__)
      Utilities.Sendlog("Got settings: " + x);

    if (val.theme)
      FontInfo.iTheme = val.theme;

    if (val.font && val.fontsize)
      FontInfo.SetFontParams(val.font, val.fontsize, val.darkmode);

    if (val.transparency != undefined)
      FontInfo.ChangeTransparency(val.transparency);

    let bytes  = AES.decrypt(val.token, Connection.DEVICE_NAME + val.user);
    sToken     = bytes.toString(Utf8);

    if (val.system && val.gateway != undefined)
      {
      sSvSystem = val.system;
      iSvGwy    = val.gateway;
      }

    if (val.gateway_name)
      {
      sSvGwy = val.gateway_name;
      }

    if (val.auto_reconn != undefined)
      Connection.iReconType = val.auto_reconn;

    if (val.event_trade_adv != undefined)
      AppMain.bEventTradeAdv = val.event_trade_adv;

    if (val.def_sett_page != undefined)
      AppMain.iDef_Sett_Page = val.def_sett_page;

    if (val.def_symbol != undefined)
      AppMain.sDef_Symbol = val.def_symbol;

    AppMain.iRuns           = val.runs;
    AppMain.iLastReviewDate = val.last_review_date;
    AppMain.sLastReviewVer  = val.last_review_ver;

  });

/*   -------------------------------------------------------------------   */

let oPopup       : Popup          | null;
let oSearch      : Search         | null;
let oAbout       : About          | null;
let oSymList     : SymbolList     | null;
let oReOrderEx   : ReOrderEx      | null;
let oTxtSearch   : TextInputEx    | null;
let oTxtUsr      : TextInputEx    | null;
let oTxtPwd      : TextInputExPwd | null;
let oModalEx     : ModalEx        | null;
let oTxtState    : TextForRef     | null;
let sRocket      = '';
//let oConnSys     : ConnectionSys  | null;
//let oMultiSelect : MultiSelect    | null;

let oPicker      : RNPickerSelect | null;
//let iSystem_Init = 0;
let bInitialGwy   = false;
let selectedItems : any[];
//let iGateway_g    = 0;
//let sSystem_g     = "Rithmic Paper Trading";

/*   =====================================================================   */

export interface ILogin
{
  user   : string; 
  theme? : number; 
  token  : string;
  eco?   : boolean;
  font?  : number;

  fontsize?     : number;
  darkmode?     : boolean;
  transparency? : boolean;
  system?       : string;
  gateway?      : number;
  gateway_name? : string;

  event_trade_adv? : boolean;
  auto_reconn?     : number;
  def_sett_page?   : number;
  def_symbol?      : string;

  last_review_date? : number;
  last_review_ver?  : string;
  runs?             : number;
 }

/*   =====================================================================   */ 

export default function T1()
  {
  if (__DEV__)    
    Utilities.Sendlog("Starting T1...");

  /*   -------------------------------------------------------------------   */

  //if (oConnSys == null)
  ConnectionSys.Init(OnAlert);

  // function BindSearch(UpdateError : (x : number) => void,
  //                     GetText     : ()=>string,
  //                     Ref         : TextInputEx | null) 
  // {
  // oTxtSearch = new TxtOp(UpdateError, GetText, Ref);
  // }

  // /*   -------------------------------------------------------------------   */

  // function BindUsr(UpdateError : (x : number) => void,
  //                  GetText     : ()=>string,
  //                  Ref         : TextInput | null) 
  // {
  // oTxtUsr = new TxtOp(UpdateError, GetText, Ref);
  // }

  // /*   -------------------------------------------------------------------   */

  // function BindPwd(UpdateError : (x : number) => void,
  //                  GetText     : ()=>string,
  //                  Ref         : TextInput | null) 
  // {
  // oTxtPwd = new TxtOp(UpdateError, GetText, Ref);
  // }

  /*   -------------------------------------------------------------------   */

  function BindEvent(onEvent    : (() => void), 
                     bSubscribe : boolean) 
  {
  if (bSubscribe == true)  
    {
    m_event.push(onEvent);

    //console.log("***added new event: " + m_event.length);
    }
  else if (bSubscribe == false)
    {
      var iZ = FindValueEvent(onEvent);

      if (iZ != -1)
        m_event.splice(iZ, 1);
        
      //console.log("***removed event: " + m_event.length);
    }  
  else  
    {
    if (__DEV__)
      Utilities.Sendlog("***UNKNOWN event: " + m_event.length);
    }
  }

  /*   -------------------------------------------------------------------   */

  function FindValueEvent(oEvent)
  {
  for (let i = 0; i < m_event.length; i++)
    if (m_event[i] == oEvent)
      return(i);

  return(AppMain.IMAGINARY);
  }

  /*   -------------------------------------------------------------------   */

  //var www_msg  = [{msg:0}];
  //var www_batt = [{batt:-2}];

  //should be inside T1()
  //const [i_batt, setBatt]                   = useState(www_batt);
  // const [i_msg, setMsg]                     = useState(www_msg);
  //const [i_update_ui, setUpdateUI]          = useState(0);
  // const [m_status, setStatus]               = useState(sLogin_State);
  //const [m_login_state, setLoginState]      = useState("");

  // const [m_user, setUser]                   = useState(sUser);
  // const [m_pwd, setPwd]                     = useState(sToken);

  // const [mkt_status, setMktStatus]          = useState(false);
  
  // const [m_usr_invalid, setUsrInvalid]      = useState(false);
  // const [m_pwd_invalid, setPwdInvalid]      = useState(false);

  const [remountCount, setRemountCount] = useState(0);
  const UpdateUI = () => {iUpdate++; setRemountCount(iUpdate)};


  const [m_eco_enabled, setEcoEnabled]      = useState(bEco);
  const [i_theme, setTheme]                 = useState(FontInfo.iTheme);
  
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  // const [selectedSystem, setSelectedSystem] = useState('');

  const [sSystem, setSystem]                = useState(sSvSystem); //"Rithmic Paper Trading");
  const [iGateway, setGateway]              = useState(iSvGwy); //0);
  const [sGatewayName, setGatewayName]      = useState(sSvGwy); //0);
  
  /*   -------------------------------------------------------------------   */

  // if (FontInfo.bLoaded == false)
  // {
  // FontInfo.LoadFonts();
  // FontInfo.bLoaded = true;
  // }

  // useEffect(() => {
  //   if (FontInfo.bLoaded == false)
  //     {
  //     FontInfo.LoadFonts();
  //     FontInfo.bLoaded = true;
  //     }
    //Utilities.Sendlog("render");
    // if (oPicker)
    //   {
    //   oPicker?.setState({value: oSystems[iSystem_Init].value});
    //   Utilities.Sendlog("Setting picker: " + oSystems[iSystem_Init].value);
    //   }
    // });

  /*   -------------------------------------------------------------------   */

  if (oSearch) //oTxtSearch)
    {
    //alert("restart");
    if (__DEV__)
      Utilities.Sendlog("Restarted...");
    //console.trace('***********************###$$#$#@$#$2 restarted....');
    }

  
    
    

  // function SetLookback(lookback)
  // {
  // oLookBackAlt = lookback;

  // iUpdate++;
  // setUpdateUI(iUpdate);
  // }

    /*   -------------------------------------------------------------------   */

  // function IsLoggedIn() : boolean
  // {
  // if (Connection.bSettingsLocal == true)
  //   {
  //   if (ConnectionMkt.oConn)
  //     return(ConnectionMkt.oConn?.GetLoginStatus());
  //   else
  //     return(false);
  //   }

  // if (ConnectionOrd.oConn)
  //   return(ConnectionOrd.oConn?.GetLoginStatus());
  // else
  //   return(false);
  // }

  /*   ------------------------------------------------------------------------   */

  function CloseModal(bCommit = true)
  {
  if (bCommit && oSettAlt != null)
    {
    ReOrder();

    ConnectionOrd.oSettings = oSettAlt;
    ConnectionOrd.SaveSettings()
    }

  oSettAlt  = null;

  // if (bCommit == true)
  //   {
  //   if (oLookBackAlt.Type != oLookBack.Type)
  //     {
  //     oLookBack = oLookBackAlt;
      
  //     //GetBars();
  //     }
  //   }
  // else
  //   oLookBackAlt = oLookBack;


    // if (oSettAlt != null)
    //   {
    //   console.log("closing modal...");  
    //   oSettings = oSettAlt;

    //   let   oStoreLocal = new Map();
        
    //   for (let i = 0; i < oSettings.length; i++)
    //       oStoreLocal.set(oSettings[i].token,
    //                       oStore.get (oSettings[i].token));


    //   oStore    = oStoreLocal;
    //   oSettAlt  = null;
    //   }

    setIsModalVisible(false);  
  }

    /*   -------------------------------------------------------------------   */

  function ReOrder()
  {
    if (oSettAlt != null)
      {
      console.log("reordering...");  
      //oSettings = oSettAlt;

      let   oStoreLocal = new Map();
        
      for (let i = 0; i < oSettAlt.length; i++)
          oStoreLocal.set(oSettAlt[i].token,
                          ConnectionMkt.oStore.get (oSettAlt[i].token));


      ConnectionMkt.oStore = oStoreLocal;
      //oSettAlt  = null;
      }
  }

  /*   -------------------------------------------------------------------   */

  function GetUsrTxt() : string
  {
  if (oTxtUsr)
    return(oTxtUsr.GetText());
  else
    return("");
  }

  /*   -------------------------------------------------------------------   */

  function GetPwdTxt() : string
  {
  if (oTxtPwd)
    return(oTxtPwd.GetText());
  else
    return("");
  }

  /*   -------------------------------------------------------------------   */

  function toggleSwitch()
    {
    setEcoEnabled(previousState => 
                  {bEco = !previousState; return(!previousState)});

    SaveData(GetUsrTxt(), GetPwdTxt(), FontInfo.iTheme, bEco);
    }

  /*   -------------------------------------------------------------------   */

  function toggleMode(bValue : boolean)
  {
  FontInfo.ChangeMode(bValue);
  UpdateUI();
  SaveData(GetUsrTxt(), GetPwdTxt(), FontInfo.iTheme, bEco);
  }

/*   -------------------------------------------------------------------   */

  function SaveData(user1  : string, 
                    token1 : string, 
                    theme1 : number, 
                    
                    eco1   : boolean)
  {
  FontInfo.iTheme = theme1;

  let ctext = AES.encrypt(token1, Connection.DEVICE_NAME + user1);

  //console.log ("user: " + user1);

  let oGwyInfo = ConnectionSys.getSavableGwyInfo(sSystem, iGateway, sGatewayName);

  let oSett : ILogin = {
                        user: user1, 
                        theme: theme1, 
                        token: ctext.toString(),
                        eco: eco1,
                        font: FontInfo.iFont,
                        fontsize: FontInfo.iFontSize,
                        darkmode: FontInfo.bDarkMode,
                        transparency: FontInfo.bTransparency,
                        system: sSystem,
                        gateway: oGwyInfo? oGwyInfo.index : iGateway, 
                        gateway_name: oGwyInfo? oGwyInfo.gwy : sGatewayName,
                        event_trade_adv: AppMain.bEventTradeAdv,
                        auto_reconn: Connection.iReconType,
                        def_sett_page: AppMain.iDef_Sett_Page,
                        def_symbol: AppMain.sDef_Symbol,

                        last_review_date: AppMain.iLastReviewDate,
                        last_review_ver: AppMain.sLastReviewVer,
                        runs: AppMain.iRuns,
                       };

  ConnectionOrd.
  SaveDataLocal("login", JSON.stringify(oSett));
  };

  /*   -------------------------------------------------------------------   */

  function SaveDataGlobal()
  {
  if (!ConnectionMkt.oConn)
    return;

  if (__DEV__)
    Utilities.Sendlog("Saving settings=> local");

  let  user1  = ConnectionMkt.oConn?.sUsr; 
  let  token1 = ConnectionMkt.oConn?.sPwd;

  let ctext = "";

  if (token1 != null)
    ctext = AES.encrypt(token1, Connection.DEVICE_NAME + user1).toString();

  let oGwyInfo = ConnectionSys.getSavableGwyInfo(sSystem, iGateway, sGatewayName);
  //console.log ("user: " + user1);

  let oSett : ILogin = {
                        user: user1 == null? "" : user1, 
                        theme: FontInfo.iTheme, 
                        token: ctext,
                        eco: false, //eco dis ConnectionMkt.bEco,
                        font: FontInfo.iFont,
                        fontsize: FontInfo.iFontSize,
                        darkmode: FontInfo.bDarkMode,
                        transparency: FontInfo.bTransparency,
                        system: sSystem,
                        gateway: oGwyInfo? oGwyInfo.index : iGateway,
                        gateway_name: oGwyInfo? oGwyInfo.gwy : sGatewayName,
                        event_trade_adv: AppMain.bEventTradeAdv,
                        auto_reconn: Connection.iReconType,
                        def_sett_page: AppMain.iDef_Sett_Page,
                        def_symbol: AppMain.sDef_Symbol,

                        last_review_date: AppMain.iLastReviewDate,
                        last_review_ver: AppMain.sLastReviewVer,
                        runs: AppMain.iRuns,
                      };


  ConnectionOrd.
  SaveDataLocal("login", JSON.stringify(oSett));
  };

  /*   -------------------------------------------------------------------   */

  // function Calc_iDt()
  // {
  // //Utilities.Sendlog("last_ssboe: " + iLastSsboe + " last_ssboe_msg: " + iLastSsboe_Msg);
  // if (iLastSsboe == iLastSsboe_Msg)
  //   return;

  // iLastSsboe  = iLastSsboe_Msg;
  // let now     = Utilities.GetSsboeNow();  
  // let iDtNow  = now - iLastSsboe;

  // if (iDtNow > iDt)
  //   iDtOverSecs++;
  // else  
  //   iDtOverSecs = 0;

  // //Utilities.Sendlog("now: " + now + " last: " + iLastSsboe + " old: " + iDt + " new: " + iDtNow);

  // iDt = iDtNow;

  // // if (iDtOverSecs > 10)
  // //   RestartMarket();
  // }

    /*   -------------------------------------------------------------------   */

  function UpdateData()
  {
  // if (bRestartOnce == true)
  //   {
  //   bRestartOnce = false;
  //   onSubmitPress();
  //   return;
  //   }
  iTick++;
  
  if (bUpdate == true)
    {
    //alert("updating on timer");  
    if (__DEV__)
      Utilities.Sendlog("updating...");  
    //setUpdateUI(iUpdate);  
    UpdateUI();
    bUpdate = false;  
    }


  if (iTick >= iTick_Count)
    {
    //  
    //alert(iUpdate);  
    //setUpdateUI(iUpdate++);
    //
    let iDiff = Utilities.GetSsboeNow() - ConnectionMkt.iLastSsboeHb;

    // if (ConnectionMkt.iLastSsboeHb != 0)
    //   Utilities.Sendlog("Last heartbeat: " + iDiff);

    if (ConnectionMkt.iLastSsboeHb != 0 &&
        iDiff                      > Connection.iReconType)
      {
      if (__DEV__)        
        Utilities.Sendlog("Stale heartbeat, disconnecting...");

      ConnectionMkt.iLastSsboeHb = 0;
      CloseConnection(true);  
      return;  
      }
    else if (Connection.iReconType      != Connection.RECON_OFF &&
             iDiff                      >= 17 && 
             ConnectionMkt.iLastSsboeHb != 0)
      {
      if (__DEV__)
        Utilities.Sendlog("Last heartbeat: " + iDiff);

        // Utilities.Sendlog("Stale heartbeat, disconnecting...");
        // CloseConnection(true);  
        // return;  
  
      if (__DEV__)
        Utilities.Sendlog("Stale heartbeat, reconnecting..." + iDiff);
      ConnectionMkt.iLastSsboeHb = 0;

      ConnectionMkt.oConn?.handleClose(undefined);
      ConnectionOrd.oConn?.handleClose(undefined);
      ConnectionRMS.oConn?.handleClose(undefined);
      ConnectionHis.oConn?.handleClose(undefined);
      return;  
      }

    //Utilities.Sendlog("Msgs: " + iMsg);  
    /*iMsg */ MessageRates.iMsgRate = ConnectionMkt.iMsg;
    //www_msg[0].msg = ConnectionMkt.iMsg; 
    //setMsg( www_msg ); //will not trigger a complete render

    iTick              = 0;
    ConnectionMkt.iMsg = 0;

    for (let [key, value] of ConnectionMkt.oStore.entries()) 
      {
      value.msgs      = value.msgs_curr;
      value.msgs_curr = 0;
      //console.log(key + " " + val);
      }

    // for (let i = 0; i < oStore.length; i++)
    //   {
    //   oStore[i].msgs      = oStore[i].msgs_curr;
    //   oStore[i].msgs_curr = 0;
    //   }

    if (iBatt != -1)  
      {
      iSecs2++;

      if (iSecs2 > 10 || iBat_Start == -2) //i_batt[0].batt == -2)
        {
        iSecs2 = 0;
        //GetDeviceInfo2();
        }
      }

    // if (bEco == true)
    //   {
    //   Utilities.Sendlog("T1: getting image snapshot...");  
    //   ConnectionMkt.GetImages();
    //   }

    //Calc_iDt();  
    }

  for (let i = 0; i < m_event.length; i++)
    {
    m_event[i]();
    }
    
  }

  /*   -------------------------------------------------------------------   */

  async function GetDeviceInfo2() 
  {
    //let batt         = await Battery.getBatteryLevelAsync();
    //www_batt[0].batt = batt * 100;

    //iBat_Start = batt * 100;
    //setBatt( www_batt ); //will not trigger a complete render
  }

    /*   -------------------------------------------------------------------   */

  function RemoveSymbol(sToken : string)
  {
   if (ConnectionMkt.RemoveSymbol(sToken) == true)
      {
      //iUpdate--;
      //alert("do update");
      //setUpdateUI(iUpdate);

      //UpdateUI();
      oSymList?.UpdateSymbols(true);

      ConnectionOrd.SaveSettings(sToken, true);
      }
  }

 /*   --------------------------------------------------------------------   */

 function SetTextSearch(txtSearch : TextInputEx | null)
 {
 oTxtSearch = txtSearch;
 }

/*   --------------------------------------------------------------------   */

 function OnAlert(conn        : Connection,
                  msg         : number,
                  data        : any,
                  store_data? : any)
  {
  //alert(conn.sName + " " + msg);

  switch (msg)
  {
    case Connection.MSG_SYS_RQ:
      // let oPaper = oSystems[0];

      // for (let [key, data] of ConnectionSys.oSystems.entries()) 
      //   {
      //   let j = 0;
      // // for (let i = 0, j = 0; i < ConnectionSys.oSystems.length; i++)

      //     //let name = ConnectionSys.oSystems[i];

      //     if (data.name == oPaper.label)
      //       continue;
            
      //     let oSys = {label:data.name, value:data.name, system:data.name, url:oPaper.url};

      //     oSystems.splice(2 + j++, 0, oSys);
      //     }

        if (data == null) //system level
          {
          if (bInitialGwy == false)
            {
            bInitialGwy = true;

            if (__DEV__)
              Utilities.Sendlog("Getting gateways for: " + sSystem);
            ConnectionSys.Init(OnAlert, sSystem);
            }
          }
        else
          {
          //gwy response
          //if (sGatewayName)

          //let iGwy = ConnectionSys.getGwy(sSystem, iGateway);

          }

      if (Connection.IsLoggedIn() == false)
        UpdateUI();

      break;

    case Connection.MSG_FORCE_LOGOUT:
      if (__DEV__)
        Utilities.Sendlog ("Forced logoff, disconnecting...");  

      CloseConnection(true);
      break;
      
    case Connection.MSG_APPLY_REORDER:
      //alert("apply reorder");
      //UpdateUI();
      //bUpdate = true;
      if (__DEV__)
        Utilities.Sendlog("applying reorder...");

      oSymList?.Refresh(true);
      break;

    case Connection.MSG_NAVIGATE_TO:
      //alert("apply reorder");
      //UpdateUI();
      //bUpdate = true;
      oSymList?.NavigateTo(data);
      break;      

    case Connection.MSG_REQ_REVIEW:
      //alert("apply reorder");
      //UpdateUI();
      //bUpdate = true;
      RequestReview();
      break;      

    case Connection.MSG_SUBSCRIBE:
      //alert("apply reorder");
      //UpdateUI();
      //bUpdate = true;
      oSymList?.OnSubscribe(data);
      break;      

    case Connection.MSG_CHANGE_THEME:
      ChangeThemeGlobal(data);
      break;

    case Connection.MSG_CHANGE_FONT:
      OB.WHITE_HEIGHT = 0;
      SaveDataGlobal();
      UpdateUI();
      break;    

    case Connection.MSG_UPDATE_BG:
      SaveDataGlobal();
      UpdateUI();
      break;

    case Connection.MSG_APP_SETTINGS:
      SaveDataGlobal();
      break;      

    case Connection.MSG_UPDATE_EVT_ADV:
      oSymList?.UpdateEvtAdv();
      SaveDataGlobal();
      break;                

    case Connection.MSG_UPDATE_FONT:
      oSymList?.UpdateFont();
      break;

    case Connection.MSG_EVT_DATA:
      oSymList?.UpdateEvt(data);
      break;      

    case Connection.MSG_EVT_AVBL:
      oSymList?.UpdateEvtAvbl(data);
      break;      
      
    case Connection.MSG_SHOW_SEARCH:
      oSearch?.Show(data);
      
      // oPopup?.Show();
      // oTxtSearch?.SetFocus();
      break;

    case Connection.MSG_SHOW_ABOUT:
      oAbout?.Show(data);
      
      // oPopup?.Show();
      // oTxtSearch?.SetFocus();
      break;

    case Connection.MSG_REF_DATA_DUPLICATE:
      //alert("duplicate alert " + oTxtSearch?.GetText1());
      oSearch?.oTxtSearch?.UpdateError(ReturnTypes.ERR_DUPLICATE, data);
      break;

    case Connection.MSG_SUB_OB:
      if (store_data)
        oSymList?.UpdateOBOnSub(store_data);
      break;

    case Connection.MSG_REF_DATA_SUCCESS:
      //alert("ref data");
      //iUpdate++;

      //bUpdate = true;

      if (data == true)    
        {
        //alert("do update");
        //setUpdateUI(iUpdate);
        //UpdateUI();
       // bUpdate = true;
        oSymList?.UpdateSymbolsOnRefData(store_data);
        //oPopup?.Hide();
        oSearch?.Hide();

        //RequestReview();
        }
      else
        oSymList?.UpdatePositionsOnRefData(store_data);
      break;

    case Connection.MSG_GET_BARS:
        //bUpdate = true;
        break;

    case Connection.MSG_REF_DATA_FAIL:
        //alert("ref fail3");
        oSearch?.oTxtSearch?.UpdateError(ReturnTypes.ERR_INVALID);
      break;

    case Connection.MSG_GET_SETTINGS:
      if (ConnectionMkt.oConn?.bInitRequestSent == false)
        {
        ConnectionMkt.GetSymbolsFromSettings();
        bUpdate = true;
        }

      if (ConnectionHis.oConn?.bInitRequestSent == false)
        ConnectionHis.GetBarsFromSettings()
      // if (ConnectionMkt.oConn == null)
      //   {
      //   //iUpdate++;
      //   //bUpdate = true;
      //   //alert("setting update on getsettings : " + Connection.oSettings.length);
      //   //UpdateUI();
      //   StartMkt();
      //   }

      // if (ConnectionHis.oConn == null)
      //   {
      //   //iUpdate++;
      //   //bUpdate = true;
      //   //alert("setting update on getsettings : " + Connection.oSettings.length);
      //   //UpdateUI();
      //   StartHis();
      //   }        
      break;      

    //case Connection.MSG_CONNECTION_ERROR:
    // case Connection.MSG_CONNECTION_CLOSED:
    case Connection.MSG_CONNECTION_TIMEOUT:
      if (conn.iType                == Connection.TYPE_ORDER_PLANT && 
          Connection.bSettingsLocal == false)
          {
          if (__DEV__)            
            Utilities.Sendlog(data + "=> closing connection on order timeout (no settings)..."); 

          CloseConnection(true);
          return;
          }

      if (conn.iSplType != Connection.CXT_TYPE_MKT)
        {
        if (__DEV__)          
          Utilities.Sendlog(data + "=> ignoring non-market timeout..."); 

        return;
        }

      if (__DEV__)
        Utilities.Sendlog(data + "=> closing connection on market timeout..."); 

      CloseConnection(true);

      //CloseConnectionOnError(conn, msg);
      break; 

    // case Connection.MSG_CONNECTION_ERROR:

    case Connection.MSG_CONNECTION_CLOSED:
    // case Connection.MSG_CONNECTION_TIMEOUT:
      // if (conn.iSplType != Connection.CXT_TYPE_MKT)
      //   return;

      // if (AppState.currentState != 'active' && ConnectionMkt.oConn?.GetLoginStatus() == true)
      //     return;

      if (conn.iSplType == Connection.CXT_TYPE_MKT)
        {
        CloseConnectionOnError(conn, msg);
        }
        
      break; 

    case Connection.MSG_LOGIN_FAIL:
      //oModalEx?.Show("Login failed");
      //   Alert.alert("Rithmic Trader", "Login Failed", [
      //     {
      //       text: "Ask me later",
      //       onPress: () => console.log("Ask me later pressed")
      //     }]);
      // alert("Login failed");

      //oTxtUsr?.UpdateData(oLoginParams?.sUsr);
      //oTxtPwd?.UpdateData(oLoginParams?.sPwd);
  
      //setUsrInvalid(true);
      //setPwdInvalid(true);
      if (__DEV__)
        Utilities.Sendlog("Login failed, closing connection...");

      CloseConnection(true);

      oTxtUsr?.UpdateError(ReturnTypes.ERR_INVALID);
      oTxtPwd?.UpdateError(ReturnTypes.ERR_INVALID);

      console.trace("#### *** reset rocket");

      sRocket = '';
      oTxtState?.UpdateText(sRocket);
      break;        

    case Connection.MSG_LOGIN_SUCCESS:
      switch(conn.iType)
        {
        case Connection.TYPE_HISTORY_PLANT:
          //Bars
          if (Connection.bSettingsLocal == true ||
              Connection.bGotSettings   == true)
            ConnectionHis.GetBarsFromSettings(ConnectionHis.oDefaultLookBack, 
                                              true);


          //  if (ConnectionHis.GetBarsFromSettings() == true)
          //    {
          //    //iUpdate++;
          //    //bUpdate = true;
          //    }

          //bUpdate = true;   

          // if (Connection.bSettingsLocal == true &&
          //     ConnectionOrd.oConn       == null)
          //    StartOrd(true);

          break;  

        case Connection.TYPE_TICKER_PLANT:
          Utilities.setTz();
          //Battery.getBatteryLevelAsync().then(level => {iBatt = level * 100});

          if (ConnectionMkt.oConn?.IsReconnected() == true)
              {
              //ConnectionMkt.GetSymbolsFromSettings();
              //bUpdate = true;


              //
              for (let [sKey, oData] of ConnectionMkt.oStore.entries()) 
                {
                if (oData.sub_mkt == true)
                  {
                  if (__DEV__)                    
                    Utilities.Sendlog("Visible items: add sub: " + oData.token);

                  ConnectionMkt.AddSymbolSubConform(oData);
                  }
                }
                //


                  
                // if (ConnectionHis.oConn?.bInitRequestSent == false)
                //   ConnectionHis.GetBarsFromSettings();
                  
                return;                
                }

          /*   -----------------------------------------------------------   */

          //Symbols
          if (Connection.bSettingsLocal == true ||
              Connection.bGotSettings   == true)
              {
              ConnectionMkt.GetSymbolsFromSettings();
              bUpdate = true;
              }

          if (ConnectionHis.oConn?.bInitRequestSent == false)
            ConnectionHis.GetBarsFromSettings();
      

          // if (Connection.bSettingsLocal == false &&
          //     ConnectionHis.oConn       == null)
          //     StartHis();

          startTimer(UpdateData);
          //bLoginPressed = false;
    
          //bUpdate = true;
          break;

        case Connection.TYPE_ORDER_PLANT:
          // startTimer(UpdateData);
          // bLoginPressed = false;

          //sLogin_State = "Sign out"
          //setStatus(sLogin_State);
          //setMktStatus(true);
          break;  

        }
      break; 

    }  
  }

 /*   --------------------------------------------------------------------   */  

  function CloseConnectionOnError(oConn : Connection,  
                                  iMsg  : number)
  {
  //let bLoggedIn = oConn?.GetLoginStatus();

  /*   -------------------------------------------------------------------   */

  //alert("error " + oConn?.sName + " msg: " + iMsg);

  // if (oConn?.iType              == Connection.TYPE_ORDER_PLANT &&
  //     Connection.bSettingsLocal == true)
  //   {
  //   ConnectionOrd.Dispose();
  //   Utilities.Sendlog("order error: auto retry since settings is local...");
  //   StartOrd(Connection.bSettingsLocal);
  //   return;
  //   }

  // if (iMsg == Connection.MSG_CONNECTION_ERROR ||
  //     iMsg == Connection.MSG_CONNECTION_TIMEOUT)
    {
    if (HandleError(oConn) == true)
      return;
    }

  /*   -------------------------------------------------------------------   */    

  if (__DEV__)
    Utilities.Sendlog ("Manually closing connection on disconnect..." + oConn?.sName + " msg: " + iMsg);  

  /*   -------------------------------------------------------------------   */

  if (iMsg == Connection.MSG_CONNECTION_CLOSED)
    {
    let iError = oTxtUsr?.state.error;

    CloseConnection(true);

    if (iError == ReturnTypes.ERR_INVALID)
      {
      oTxtUsr?.UpdateError(ReturnTypes.ERR_INVALID);
      oTxtPwd?.UpdateError(ReturnTypes.ERR_INVALID);
      }
    }
  else if (IsErrorOK(oConn, iMsg) == false)
    {
    //alert("error : " + iMsg + " conn: " + oConn?.sName);
    CloseConnection(true);
    //oTxtState?.UpdateText('💥');
    }
  else
    CloseConnection(true);

  // if (bLoggedIn == false)
  //   setLoginState(''); //'💥');
  }

/*   --------------------------------------------------------------------   */

function IsErrorOK(oConn  : Connection,
                   iMsg   : number) : boolean
{
if (iMsg == Connection.MSG_CONNECTION_ERROR)
  return(false);
else if (iMsg == Connection.MSG_CONNECTION_TIMEOUT)
  {
  if (oConn?.iType == Connection.TYPE_ORDER_PLANT)
    {
    if (Connection.bSettingsLocal == true)
      return(true);
    }
  }

return(false);
}

/*   --------------------------------------------------------------------   */

function HandleError(oConn : Connection) : boolean
{
  switch (oConn?.iType)
    {
    case Connection.TYPE_PNL_PLANT:
      ConnectionRMS.Dispose();
      // Utilities.Sendlog ("***Ignoring RMS...");
      // return(true);

      if (Connection.bSettingsLocal == true)
        {
        if (__DEV__)          
          Utilities.Sendlog ("***Ignoring RMS...");  

        return(true);
        }
      else
        return(false);


    case Connection.TYPE_ORDER_PLANT:
      ConnectionOrd.Dispose();

      // if (oConn?.iRetry < Connection.MAX_RETRY)
      //   {
      //   Utilities.Sendlog ("***Retrying Order...");
      //   StartOrd(Connection.bSettingsLocal, oConn?.iRetry + 1);
      //   return(true);
      //   }
      // else
        {
        if (Connection.bSettingsLocal == true)
          {
          if (__DEV__)            
            Utilities.Sendlog ("***Ignoring Order...");  

          return(true);
          }
        else
          return(false);
        }

    case Connection.TYPE_TICKER_PLANT:
      ConnectionMkt.Dispose();

      // if (oConn?.iRetry < Connection.MAX_RETRY)
      //   {
      //   Utilities.Sendlog ("***Retrying Market...");
      //   StartMkt(oConn?.iRetry + 1);
      //   return(true);
      //   }
      // else
        return(false);

    case Connection.TYPE_HISTORY_PLANT:
      ConnectionHis.Dispose();

      // if (oConn?.iRetry < Connection.MAX_RETRY)
      //   {
      //   Utilities.Sendlog ("***Retrying History...");
      //   StartHis(oConn?.iRetry + 1);
      //   return(true);
      //   }
      // else
        return(false);

    // case Connection.TYPE_PNL_PLANT:
    //   ConnectionRMS.Dispose();

    //   // if (oConn?.iRetry < Connection.MAX_RETRY)
    //   //   {
    //   //   Utilities.Sendlog ("***Retrying History...");
    //   //   StartHis(oConn?.iRetry + 1);
    //   //   return(true);
    //   //   }
    //   // else
    //     return(false);        
    }

 return(false);   
}

/*   --------------------------------------------------------------------   */

function PowerOff()
  {
  if (__DEV__)    
    Utilities.Sendlog ("Power off pressed, disconnecting...");  

  CloseConnection(true);
  }

 /*   --------------------------------------------------------------------   */

 async function RequestReview()
 {
  let bCanDo = false;

  /*   -------------------------------------------------------------------   */

  if (AppMain.bReviewChecked)
    return;

  /*   -------------------------------------------------------------------   */

  AppMain.bReviewChecked = true;

  /*   -------------------------------------------------------------------   */

  if (AppMain.sLastReviewVer && 
      AppMain.sLastReviewVer == StringTable.APP_VERSION)
    return;

  /*   -------------------------------------------------------------------   */    

  if (AppMain.iRuns && AppMain.iRuns > 10 && !AppMain.iLastReviewDate)
    bCanDo = true;

  /*   -------------------------------------------------------------------   */

  if (bCanDo == false && AppMain.iLastReviewDate)
    {
    let d1    = AppMain.iLastReviewDate;
    let d2    = Date.now();

    let iDays = Math.ceil( (d2 - d1) / (1000 * 60 * 60 * 24))

    if (iDays > 45 && AppMain.iRuns && AppMain.iRuns > 10)
      bCanDo = true;
    }

  /*   -------------------------------------------------------------------   */

  if (bCanDo == false)
    return;

  /*   -------------------------------------------------------------------   */    

  //alert('requesting review...');
  try
    {
    if (await StoreReview.hasAction()) 
      {
      AppMain.iRuns           = 0;
      AppMain.iLastReviewDate = Date.now();
      AppMain.sLastReviewVer  = StringTable.APP_VERSION;
      SaveDataGlobal();

      StoreReview.requestReview();
      }
    }
  catch(e : any)
    {
    if (__DEV__)      
      Utilities.Sendlog("Error: request review=>" + e.name + " " + e.message);
    }
 }

/*   --------------------------------------------------------------------   */

function CloseConnection(bReset : boolean = false)
  {
  if (__DEV__)    
    Utilities.Sendlog ("**Closing connection**" + bReset);  

  //setLoginState("");

  //oTxtState?.UpdateText('')
  oSearch?.oTxtSearch?.UpdateError(ReturnTypes.OK);

  sRocket = '';

  //if (ConnectionOrd.oConn)// && !oModalEx?.state.visible)

  //setMktStatus(false);
  stopTimer();

  if (oTmOut)
    {
    clearTimeout(oTmOut);
    oTmOut = undefined;
    }

  //iUpdate       = 0;
  bLoginPressed          = false;
  AppMain.bReviewChecked = false;

  //sLogin_State = "Sign in";
  //setStatus(sLogin_State);

  //stopTimer();

  //oPopup?.Hide();
  oSearch?.HideNoAnimation();
  oAbout?.HideNoAnimation();
  
  ConnectionOrd.Dispose();
  ConnectionMkt.Dispose();
  ConnectionHis.Dispose();
  ConnectionRMS.Dispose();
  Connection.ResetHandle();

  Keyboard.dismiss();

  if (__DEV__)
    Utilities.Sendlog("Clearing stores...");

  Connection.oStore.clear();
  Connection.oOBStore.clear();
  Connection.oAccStore.clear();
  Connection.oPosStore.clear();
  Connection.oOrdStore.clear();
  Connection.oBrackets.clear();

  oReOrderEx?.HideNoAnimation();
  oReOrderEx?.Reset();
  oSymList?.Refresh(false);
  ModalEx.oModalEx?.HideNoAnimation();

  if (bReset == true)
    {
    //alert("updating on disconnect");
    //iUpdate++;
    //setUpdateUI(iUpdate);
    UpdateUI();
    }

  if (__DEV__)
    Utilities.Sendlog ("**Close connection end**");
  }

/*   ---------------------------------------------------------------------   */

function OnPopupMsg(iMsg : number)
{
switch(iMsg)
  {
  case ReOrderEx.MSG_SIGN_OFF:
      //oReOrderEx?.Hide();
      PowerOff();
      break;  
  case ReOrderEx.MSG_SEARCH:
      oSearch?.Show();

      //ConnectionOrd.oConn?.CloseSimulate();

      // oPopup?.Show();
      // oTxtSearch?.SetFocus();
      break;        

  case ReOrderEx.MSG_ABOUT:
      oAbout?.Show();      
  }
}

/*   ---------------------------------------------------------------------   */

function ShowPopup()
{
  if (oReOrderEx)
    {
    oReOrderEx.OnPopupMsg = OnPopupMsg;
    oReOrderEx.Toggle();
    }
  // if (oSettAlt != null)
  // {
  //   ConnectionOrd.oSettings = oSettAlt;
  //   oSettAlt  = null;
  // }

  // setIsModalVisible(true);
}

/*   ---------------------------------------------------------------------   */

function GetInitialGwy()
{
let sGwy = sGatewayName? 
            ConnectionSys.getGwyFromGwyName(sSystem, sGatewayName) 
            : ConnectionSys.getGwy(sSystem, iGateway);


// if (sGwy)
//   bGwySet = true;
// else
//   bGwySet = false;

return(sGwy);
}

/*   ---------------------------------------------------------------------   */

function onSubmitPress()
  {
  //if (FontInfo.bLoaded == false)
   // {
    //FontInfo.LoadFonts();
   // FontInfo.bLoaded = true;
    //}

  oTxtPwd?.HidePwd();

  /*   -------------------------------------------------------------------   */

  if (bLoginPressed == true)
    {
    if (__DEV__)      
      Utilities.Sendlog("Submit button already pressed...");  
    return;
    }

  /*   -------------------------------------------------------------------   */

  if (__DEV__)
    Utilities.Sendlog("Submit pressed, disconnecting if connected...");  

  CloseConnection();

  /*   -------------------------------------------------------------------   */

  if (oTxtUsr?.GetText().length == 0)
    {
    oTxtUsr?.UpdateError(ReturnTypes.ERR_INVALID);
    return;
    }
  else
    oTxtUsr?.UpdateError(ReturnTypes.OK);

  /*   -------------------------------------------------------------------   */

  if (oTxtPwd?.GetText().length == 0)
    {
    oTxtPwd?.UpdateError(ReturnTypes.ERR_INVALID);
    return;
    }
  else
    oTxtPwd?.UpdateError(ReturnTypes.OK);

  /*   -------------------------------------------------------------------   */

  // Utilities.Sendlog("Closing connection on submit...");
  // CloseConnection();

  // if (m_user.length == 0)
  //   {
  //   setUsrInvalid(true);
  //   return;
  //   }
  // else
  //   setUsrInvalid(false);

  // if (m_pwd.length == 0)
  //   {
  //   setPwdInvalid(true);
  //   return;
  //   }
  // else
  //   setPwdInvalid(false);

  //if (bLoginPressed == false)
    {
    

    /*   ---------------------------------------------------------------------   */

    Keyboard.dismiss();  

    /*   ---------------------------------------------------------------------   */

    let spSys = ConnectionSys.getSystem(sSystem);

    if (!spSys)
      {
      alert("Select a valid system");
      return;
      }

    /*   ---------------------------------------------------------------------   */  
  
    let sUri  = ConnectionSys.getTargetableUri(sSystem, iGateway, sGatewayName);

    // let spGwy = ConnectionSys.getUriFromGwyName(sSystem, sGatewayName);

    // if (!spGwy)
    //   spGwy = ConnectionSys.getUri(sSystem, iGateway);

    if (!sUri) //(!spGwy)
      {
      alert("Select a valid gateway");
      return;
      }

    /*   ---------------------------------------------------------------------   */  
  
    bLoginPressed = true;
    sRocket       = '🚀';
    oTxtState?.UpdateText(sRocket);
    //setLoginState('🚀');

    /*   ---------------------------------------------------------------------   */

    // if (oTmOut)
    //   {
    //   clearTimeout(oTmOut);
    //   oTmOut = undefined;
    //   }

    oTmOut = setTimeout(() => 
      {
      bLoginPressed = false;
      oTmOut        = undefined;
      }, 1000);
  
    /*   -------------------------------------------------------------------   */
  
    oLoginParams = new LoginParams(oTxtUsr?.GetText(), 
                                   oTxtPwd?.GetText(), 
                                   spSys,
                                   sUri);
                                   //oSystems[iSystem].system,
                                   //oSystems[iSystem].url)
    
    //setMktStatus(true);
    //ConnectionOrd.oConn?.SetLoginStatus(true);
    //StartMkt();


    //eco dis
    //ConnectionMkt.bEco = m_eco_enabled;

    /*   ---------------------------------------------------------------------   */

    if (!AppMain.iRuns)
      AppMain.iRuns = 1;
    else
      AppMain.iRuns++;

    /*   ---------------------------------------------------------------------   */

    SaveData(GetUsrTxt(), GetPwdTxt(), FontInfo.iTheme, m_eco_enabled);

    /*   ---------------------------------------------------------------------   */

    if (Connection.DEVICE_NAME == Connection.DEVICE_WEB)
      {
      StartConn(); //StringTable.DEBUG);

      // StartOrd();
      // StartMkt();
      // StartHis();
      return;
      }

    /*   ---------------------------------------------------------------------   */

    ConnectionOrd.
    GetWindowsLocal((sJSON)=> 
      {
      if (sJSON == null)
        {
        if (__DEV__)          
          Utilities.Sendlog("get local settings null..."); 

        //StartOrd();
        StartConn();
        return;
        }
    
      try
        {
        let settings  = JSON.parse(sJSON);

        //if (settings.length > 0)
          {
          Connection.oSettings      = settings;
          Connection.bSettingsLocal = true;

          if (__DEV__)
            Utilities.Sendlog("PARSED local settings : " + sJSON); 

          StartConn(true);

          // StartMkt();
          // StartHis();
          // StartOrd(true);
          }
        }
      catch(error)
        {
        if (__DEV__)
          Utilities.Sendlog("get settings error: " + error + " => " + sJSON); 

        StartConn();
        }
      });

    /*   -----------------------------------------------------------------   */

    }
  }

/*   ---------------------------------------------------------------------   */

function StartConn(bLocalSettings = false)
{
Connection.oOnGenAlert    = OnAlert;
Connection.sDisplaySystem = sSystem;

Connection.sDisplayGwy    = sGatewayName? sGatewayName : 
                            ConnectionSys.getGwy(sSystem, iGateway);

if (bLocalSettings == true)
  {
  StartMkt();
  StartHis();
  StartRMS();
  //StartOrd(true);
  StartOrd(true);

  // setTimeout(() => {
  //   StartOrd(true);
  // }, 5000); 

  }
else
  {
  // setTimeout(() => {
  //   StartOrd();
  // }, 5000); 

  StartOrd();
  StartMkt();
  StartRMS();
  StartHis();
  }
}

/*   ---------------------------------------------------------------------   */

function StartOrd(bSettingsLocal = false,
                  iRetryCount    = 0) 
{
try
  {
  Connection.bSettingsLocal = bSettingsLocal;

  if (oLoginParams != null)
    ConnectionOrd.Init(oLoginParams, OnAlert, iRetryCount);
  // else
  //   setLoginState('💥');
  }
catch(error)
  {
  //setLoginState('💥');
  }
}

/*   ---------------------------------------------------------------------   */

function StartHis(iRetryCount = 0) 
{
try
  {
  if (oLoginParams != null)
    ConnectionHis.Init(oLoginParams, OnAlert, iRetryCount); 
  // else
  //   setLoginState('💥');
  }
catch(error)
  {
  //setLoginState('💥');
  }
}

/*   ---------------------------------------------------------------------   */

function StartMkt(/*bReconnect  = false,*/
                  iRetryCount = 0)
{
try
    {
    if (oLoginParams != null)      
      ConnectionMkt.Init(oLoginParams, OnAlert, iRetryCount);
    // else
    //   setLoginState('💥');
    }
catch(error)
    {
    //setLoginState('💥');
    }
}

/*   ---------------------------------------------------------------------   */

function StartRMS(/*bReconnect  = false,*/
                  iRetryCount = 0)
{
try
    {
    if (oLoginParams != null)      
      ConnectionRMS.Init(oLoginParams, OnAlert, iRetryCount);  
    // else
    //   setLoginState('💥');
    }
catch(error)
    {
    //setLoginState('💥');
    }
}

/*   ---------------------------------------------------------------------   */

function ChangeTheme(theme)
{
FontInfo.iTheme = theme;

//SaveDataGlobal();
SaveData(GetUsrTxt(), GetPwdTxt(), FontInfo.iTheme, m_eco_enabled);
//AsyncSetData("login", JSON.stringify({user:m_user, theme:iTheme}));

setTheme(theme);

if (__DEV__)
  Utilities.Sendlog("Changed theme: " + theme + ": " + oThemes[i_theme].theme);
};

/*   ---------------------------------------------------------------------   */

function ChangeThemeGlobal(theme)
{
FontInfo.iTheme = theme;

SaveDataGlobal();
//SaveData(GetUsrTxt(), GetPwdTxt(), iTheme, m_eco_enabled);
//AsyncSetData("login", JSON.stringify({user:m_user, theme:iTheme}));

setTheme(theme);

if (__DEV__)
  Utilities.Sendlog("Changed theme: " + theme + ": " + oThemes[i_theme].theme);
};

/*   ---------------------------------------------------------------------   */
/*   *********************************************************************   */
/*   ---------------------------------------------------------------------   */

function Sample_Login()
{
if (Connection.IsLoggedIn())
  {
  //setAnimation();    
  //alert("not showing login");

  sRocket = '';
  //oTxtState?.UpdateText(sRocket);

  return(null);
  }
//  <View style={{flex:1}}>
//       <TextInputEx
//         getstyle= {()=>{return([styles.login_input, {}])}}
//         placeholder="Enter such as aapl.q, es.cme"
//         placeholderTextColor="grey"
  
//         autoCorrect={false}
//         spellCheck={false}
//         autoCompleteType='off'
  
//         onBindTxtEvent={BindUsr}
//         onSubmitEditing={ConnectionMkt.GetSymbolInfo}
//     />

//  </View>
  // );
else
  {
  //alert("showing login");
  return(

  <View style={[styles.container2, {opacity:1}]}>

  <View style={styles.login_header}>
  <Text style={[FontInfo.appStyles.txt_bold, styles.row_header, {fontSize:FontInfo.iFontSize+4}]}>
      Rithmic Login
      </Text>
  </View>

  <View style={[styles.login_container, {marginTop:-1, backgroundColor: FontInfo.sBackground}]}>

  <View style={{backgroundColor:'transparent', marginTop:10}}>

  <TextInputEx
        ref={node => { oTxtUsr = node; }}
        getstyle= {()=>{return(oTxtUsr?.state.error == ReturnTypes.ERR_INVALID ? 
                        [FontInfo.appStyles.txt_normal, styles.login_input_invalid, {borderBottomColor:'red', fontSize:FontInfo.iFontSize+4}] : 
                        [FontInfo.appStyles.txt_normal, styles.login_input, {color:FontInfo.sForeground, borderBottomColor:FontInfo.sDivider, fontSize:FontInfo.iFontSize+4}])}}
        hideErrorIcon={true}                        
        placeholder="User Id"
        placeholderTextColor="grey"
  
        initValue={sUser}
        autoCorrect={false}
        spellCheck={false}
        autoCompleteType='off'
  
        onChangeText={text=>{sUser = text; SaveData(text, GetPwdTxt(), FontInfo.iTheme, m_eco_enabled)}}
        onSubmitEditing={()=>
                {
                  onSubmitPress();
                }}
    />

<TextInputExPwd
        ref={node => { oTxtPwd = node; }}
        getstyle= {()=>{return(oTxtPwd?.state.error == ReturnTypes.ERR_INVALID ? 
                        [FontInfo.appStyles.txt_normal, styles.login_input_invalid, {borderBottomColor:'red', fontSize:FontInfo.iFontSize+4}] : 
                        [FontInfo.appStyles.txt_normal, styles.login_input, {color:FontInfo.sForeground, borderBottomColor:FontInfo.sDivider, fontSize:FontInfo.iFontSize+4}])}}
        placeholder="Password"
        placeholderTextColor="grey"
  
        initValue={sToken}
        autoCorrect={false}
        spellCheck={false}
        autoCompleteType='off'

        secureTextEntry={true}
  
        onChangeText={text=>{sToken = text; SaveData(GetUsrTxt(), text, FontInfo.iTheme, m_eco_enabled)}}
        onSubmitEditing={()=>
                {
                  onSubmitPress();
                }}
    />    

<RNPickerSelect
                 style={GetPickerStyles()}
                 //textInputProps={{}}
                 //ref={node => { oPicker = node; Utilities.Sendlog("Setting picker..."); }}
                 onValueChange={(sValue, iIndex) => { 
                                    if (sRocket == '🚀')
                                      CloseConnection();

                                    ConnectionSys.Init(OnAlert, sValue); 
                                    setGateway(0);
                                    setSystem(sValue); 
                                    setGatewayName(ConnectionSys.getGwy(sValue, 0));
                                    //SaveData(GetUsrTxt(), GetPwdTxt(), FontInfo.iTheme, m_eco_enabled); /*iSystem_Init = iIndex; /*oPicker?.setState({value: oSystems[iSystem_Init].value}); /*Utilities.Sendlog("url: " + oSystems[iSystem].url); setSystem(iIndex);*/ /*iSystemIndex = iIndex; */ 
                                  }}
                 //onValueChange={(sValue, iIndex) => {sSystem_g = sValue; setSystem(sValue)}}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={Array.from(ConnectionSys.oSystems.values())}
                 //selectedValue={sSystem}
                 //onClose={()=>{ ConnectionSys.Init(OnAlert, sSystem_g); setGateway(0); setSystem(sSystem_g) }}
                 value={sSystem}

                 //onClose={()=>{ Utilities.Sendlog("closing picker..."); setSystem(iSystem_Init) }}

                //  items={[
                //      { label: "Rithmic Paper Trading", value: "Rithmic Paper Trading" },
                //      { label: "Rithmic Paper Trading (beta)", value: "Rithmic Paper Trading (beta)" },
                //  ]}
             />

<RNPickerSelect
                 style={GetPickerStyles()}
                 ref={node => { oPicker = node; 

                                if (__DEV__)
                                  Utilities.Sendlog("Setting gwy picker..."); 
                              }}
                 onValueChange={(sValue, iIndex) => {   
                                if (sRocket == '🚀')
                                    CloseConnection();

                                  setGateway(iIndex); 
                                  setGatewayName(ConnectionSys.getGwy(sSystem, iIndex));
                                  //SaveData(GetUsrTxt(), GetPwdTxt(), FontInfo.iTheme, m_eco_enabled); /*iSystem_Init = iIndex; /*oPicker?.setState({value: oSystems[iSystem_Init].value}); /*Utilities.Sendlog("url: " + oSystems[iSystem].url); setSystem(iIndex);*/ /*iSystemIndex = iIndex; */ 
                                }}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={ConnectionSys.getGateways(sSystem)}

                 //onClose={()=>{setGateway(iGateway_g)}}
                //modalProps={{ style = {[height:200]} }}
                 //pickerProps={{}}
                 //InputAccessoryView={()=>{return(null)}}
                 value={
                        ConnectionSys.getInitialGwy(sSystem, iGateway, sGatewayName)
                        // sGatewayName? 
                        // ConnectionSys.getGwyFromGwyName(sSystem, sGatewayName) 
                        // : ConnectionSys.getGwy(sSystem, iGateway)
                       }
                 //value={ConnectionSys.oSystems.get(sSystem)?.gateways[iGateway]} //oSystems[iSystem].value}

                 //onClose={()=>{ Utilities.Sendlog("closing picker..."); setSystem(iSystem_Init) }}

                //  items={[
                //      { label: "Rithmic Paper Trading", value: "Rithmic Paper Trading" },
                //      { label: "Rithmic Paper Trading (beta)", value: "Rithmic Paper Trading (beta)" },
                //  ]}
             />

  {/* </View> */}

  {/* <View style={{ flex: 1 }}>
        <MultiSelect
          hideTags
          items={items}
          uniqueKey="id"
          ref={(component) => { oMultiSelect = component }}
          onSelectedItemsChange={(items) => {selectedItems = items}}
          selectedItems={selectedItems}
          selectText="Pick Items"
          searchInputPlaceholderText="Search Items..."
          onChangeInput={ (text)=> console.log(text)}
          altFontFamily="ProximaNova-Light"
          tagRemoveIconColor="#CCC"
          tagBorderColor="#CCC"
          tagTextColor="#CCC"
          selectedItemTextColor="#CCC"
          selectedItemIconColor="#CCC"
          itemTextColor="#000"
          displayKey="name"
          searchInputStyle={{ color: '#CCC' }}
          submitButtonColor="#CCC"
          submitButtonText="Submit"
        />
        <View>
          {oMultiSelect?.getSelectedItemsExt(selectedItems)}
        </View>
      </View> */}

    <View style={{backgroundColor:'transparent'}}>
    <TouchableOpacity
      style={[styles.button]}
      onPress={onSubmitPress}
    >

    {/* <View style={{backgroundColor:'transparent', flexDirection: 'row'}}> */}
      <Text style={[FontInfo.appStyles.txt_bold, styles.text, {fontSize:FontInfo.iFontSize+4}]}>Sign In</Text>

    {/* </View> */}

    <TextForRef text={sRocket} ref={node => { oTxtState = node; }} style={[FontInfo.appStyles.txt_bold, {position:'absolute', right:-35, bottom:0, textAlign:'left', backgroundColor:'transparent', fontSize: FontInfo.iFontSize + 8, paddingTop:0,}]} />
    </TouchableOpacity>

    </View>

    {/* Login Status */}
    
    <View style={{width:250, alignItems:'center', backgroundColor:'transparent', flexDirection: 'row', alignSelf:'center', justifyContent:'center', marginTop:14, marginBottom:0}}>
 
    {/* <View style={{backgroundColor:'transparent', justifyContent:'center',  }}>
    <Text style={!m_eco_enabled?{display:"none"}:{marginLeft:6, color:'grey', backgroundColor:'transparent', textAlign:'right'}}>💕 Eco Saver</Text>
    <Text style={m_eco_enabled?{display:"none"}:{marginLeft:6, color:'lightgrey', backgroundColor:'transparent', textAlign:'right'}}>Eco Saver</Text>
    </View>

    <Switch style={{marginTop:0, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
      trackColor={{ false: "#dcdcdc", true: "palegreen" }}
      thumbColor={m_eco_enabled ? "white" : "white"}
      activeThumbColor="white"
      ios_backgroundColor="white"
      onValueChange={toggleSwitch}
      value={m_eco_enabled}
    /> */}

    <View style={{marginTop:4, backgroundColor:'transparent', justifyContent:'center', width:22, height:22}}>
    {/* <Ionicons name="sunny" size={24} color="yellow" /> */}
    {/* <MaterialCommunityIcons name="weather-night" size={22} color={FontInfo.bDarkMode? 'yellow':'darkgray'} /> */}
    {/* <SvgUri uri="../assets/images/weather-night.svg" fill="red" width='100%' height='100%'/> */}
    {/* <SvgComponent color={FontInfo.bDarkMode? 'yellow':'darkgray'}  /> */}
    <SvgDarkMode scale={.95} color={FontInfo.bDarkMode? 'yellow':'darkgray'}  />
    </View>

    <SwitchNE style={{marginTop:0, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
      trackColor={{ false: "#dcdcdc", true: "palegreen" }}
      ios_backgroundColor="white"
      onValueChange={(value)=> {toggleMode(value)}}
      value={FontInfo.bDarkMode}
    />

    {/* <View style={{backgroundColor:'transparent', justifyContent:'center',  }}>
    <MaterialCommunityIcons name="weather-night" size={24} color="yellow" />
    </View> */}

    </View>

   </View>

   <Sample_Theme/>

  </View>

  {/* <View style={{backgroundColor:'yellow', height:20}}></View> */}

  

  <Text style={[FontInfo.appStyles.txt_normal, styles.row_version, {marginTop:15, color:oThemes[i_theme]?.color}]}>
  v{StringTable.APP_VERSION}  © 2024 Rithmic, LLC {}
  </Text>

  {/* <TouchableOpacity style={{display:Connection.IsWeb()? 'flex':'none'}} onPress={()=>{Linking.openURL('https://rithmic.com/demo.html#sign-up')}}>
  <Text style={[FontInfo.appStyles.txt_normal, styles.row_version, {marginTop:5, color:oThemes[i_theme]?.color}]}>
  Sign Up
  </Text>
  </TouchableOpacity> */}

  </View>
  ); 
  }
}

/*   -------------------------------------------------------------------   */

function Sample_Theme()
{
return(
  <View style={{marginTop:25, marginBottom:10, opacity:.8, backgroundColor:'transparent',  flexDirection:'row'}}>

    <TouchableOpacity style={{borderRadius:10, 
                              borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Blue?'#04cd25':'transparent', 
                              backgroundColor:'#7b68ee', width:20, height:20, marginRight:6}}
      onPress={()=>
      {
        // if (ConnectionMkt.oConn)
        //   Connection.oOnGenAlert(ConnectionMkt.oConn, Connection.MSG_GET_BARS)
        ChangeTheme(UTheme.Blue);
      }}>
    </TouchableOpacity>

    <TouchableOpacity style={{borderRadius:10, 
                              borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Green?'#04cd25':'transparent', 
                              backgroundColor:'lightgreen', width:20, height:20, marginRight:6}}
      onPress={()=>
      {
        ChangeTheme(UTheme.Green);
      }}>
    </TouchableOpacity>
    

    <TouchableOpacity style={{borderRadius:10, 
                              borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Gray?'#04cd25':'transparent', 
                              backgroundColor:'darkslategray', width:20, height:20, marginRight:6}}
      onPress={()=>
      {
        ChangeTheme(UTheme.Gray);
      }}>
    </TouchableOpacity>

    <TouchableOpacity style={{borderRadius:10, 
                              borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Metal?'#04cd25':'transparent', 
                              backgroundColor:'grey', width:20, height:20, marginRight:6}}
      onPress={()=>
      {
        ChangeTheme(UTheme.Metal);

      }}>
    </TouchableOpacity>

    <TouchableOpacity style={{borderRadius:10, 
                              borderWidth:2, borderColor:FontInfo.iTheme==UTheme.Multi?'#04cd25':'transparent', 
                              backgroundColor:'violet', width:20, height:20}}
      onPress={()=>
      {
        ChangeTheme(UTheme.Multi);

      }}>
    </TouchableOpacity>      
    
    </View>
); 
}

/*   -------------------------------------------------------------------   */

const setAnimation = () => {
  LayoutAnimation.configureNext({
    duration: 200,
    update: {
      type: LayoutAnimation.Types.easeIn,
      springDamping: 0.7,
    },
  });
  LayoutAnimation.configureNext({
    duration: 400,
    create: {
      type: LayoutAnimation.Types.easeIn,
      property: LayoutAnimation.Properties.scaleXY,
      springDamping: 0.7,
    },
  });

  // LayoutAnimation.configureNext({
  //   duration: 400,
  //   delete: {
  //     type: LayoutAnimation.Types.easeOut,
  //     property: LayoutAnimation.Properties.scaleXY,
  //     springDamping: 0.7,
  //   },
  // });

};

function Sample_Topbar()
{
if (!Connection.IsLoggedIn() || isModalVisible)
  return(null);
else
  {
  //setAnimation();

  return(
    <View style= {[{ flexDirection:'row', marginTop:4, marginBottom:4, justifyContent:'flex-end', width:'100%', height:40, opacity:1, backgroundColor:'transparent'}]}>

    {/* Sign out */}
    <TouchableOpacity
          style={[styles.button_logout, {position:'absolute', left:6, marginRight:6, backgroundColor: 'orange'}]}
          onPress={ShowPopup}
        >
 
      <FontAwesome style={{ marginBottom: 0 }} name="bars" size={16} color="white" />
    </TouchableOpacity>  

    {/* <View style={{marginLeft:45, flex:1, backgroundColor:'transparent', marginTop:-2, alignItems:'center', flexDirection:'column'}}>
    <View style={{backgroundColor:'transparent', paddingHorizontal:10, paddingBottom:2, borderBottomLeftRadius:10, borderBottomRightRadius:10, marginTop:0}}>
    <Text style={[FontInfo.appStyles.txt_bold, {color:'rgba(255, 255, 255, .8)', }]}>{sSystem + " - " + ConnectionSys.getGwy(sSystem, iGateway)}</Text> */}
    {/* <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sWhiteTp}]}>{ConnectionSys.getGwy(sSystem, iGateway)}</Text> */}
    {/* </View>
    </View> */}

    {/* Sign out */}
    {/* <TouchableOpacity
          style={[styles.button_logout, {marginRight:6, backgroundColor: 'salmon'}]}
          onPress={PowerOff}
        >

        <FontAwesome style={{ marginBottom: -1 }} name="power-off" size={20} color="white" />
    </TouchableOpacity> */}
  
    <TouchableOpacity
          style={[styles.button_logout, {marginRight:6, backgroundColor: 'cornflowerblue'}]}
          
          onPress={()=>
            {
             // alert("Hi")
            //Alert.alert(StringTable.APP_NAME, "some messaage");
            // Alert.alert('Alert Title', 'My Alert Msg', [
            //   {
            //     text: 'Cancel',
            //     onPress: () => console.log('Cancel Pressed'),
            //     style: 'cancel',
            //   },
            //   {text: 'OK', onPress: () => console.log('OK Pressed')},
            // ]);

            oSearch?.Show();

            // ConnectionMkt.oConn?.CloseSimulate();
            // ConnectionRMS.oConn?.CloseSimulate();
            // ConnectionOrd.oConn?.CloseSimulate();
            // ConnectionHis.oConn?.CloseSimulate();
            // alert()
            //oPopup?.Show();
            // oTxtSearch?.SetFocus();
            }}
        >
    <FontAwesome style={{ marginBottom: -3 }} name="plus" size={18} color="white" />
    </TouchableOpacity>
    {/* </View> */}
  
    </View>
 
  );} 
}

/*   -------------------------------------------------------------------   */

function Sample_SymbolSearch()
{
if (!Connection.IsLoggedIn())  
  return(null);
else
  return(
    <Popup ref={node => { oPopup = node; }}> 
    <View style={{alignItems:'center', backgroundColor:'transparent', marginHorizontal:0}}>

    <TextInputEx
          ref={node => { oTxtSearch = node; }}
          getstyle= {()=>{return( oTxtSearch?.state.error == ReturnTypes.ERR_INVALID? 
                          [FontInfo.appStyles.txt_normal, styles.search_input_invalid, {color:FontInfo.sForeground, backgroundColor:'transparent', fontSize:FontInfo.iFontSize+4}] : 
                          [FontInfo.appStyles.txt_normal, styles.search_input, {color:FontInfo.sForeground, borderBottomColor:FontInfo.sDivider, fontSize:FontInfo.iFontSize+4}])}}
          placeholder="enter such as aapl.q, es.cme"
          placeholderTextColor="grey"
          //initValue={"init"}

          
          autoCorrect={false}
          spellCheck={false}
          autoCompleteType='off'
          //removeClippedSubviews={false}
    
          // onChangeText={text=>{}}
          //onBindTxtEvent={BindSearch}

          onSubmitEditing={()=>
                  {
                  //alert(oTxtSearch?.GetText1());
                  let iErr = ConnectionMkt.GetSymbolInfo(oTxtSearch?.GetText()); 
                  //alert("txt submit: " + iErr);
                  oTxtSearch?.UpdateError(iErr);
                  }}
      />

      <View style={{ flexDirection: 'row', alignSelf: 'center', backgroundColor:'transparent' }}>
    
      <TouchableOpacity
            style={[styles.button_plus, {}]}
            
            onPress={()=>
              {
              //alert(oTxtSearch?.GetText1());
              let iErr = ConnectionMkt.GetSymbolInfo(oTxtSearch?.GetText()); 
              //alert("button submit: " + iErr);
              oTxtSearch?.UpdateError(iErr);
              }}
          >
     
      <FontAwesome style={{ marginBottom: -3 }} name="plus" size={30} color="white" />
    
      {/* <Text>{new Date().toTimeString()}</Text> */}
    
      </TouchableOpacity>
      </View>

    </View>
    </Popup>
   );
}    

/*   -------------------------------------------------------------------   */

return(
  // <Sample_Login/>
  <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : "height"} style={[styles.container, {}]}>
    <StatusBar
    backgroundColor={oThemes[i_theme].top}
    barStyle={oThemes[i_theme]?.status? "light-content":"dark-content"}/>

    

    <View style={{flex:1, backgroundColor:oThemes[FontInfo.iTheme].bg}}>
    
      <ImageBackground  resizeMode={'stretch'} // or cover
                        style={{flex: 1}} // must be passed from the parent, the number may vary depending upon your screen size
                        source={oThemes[FontInfo.iTheme]?.file}>

        <SafeAreaView style={[styles.container, {}]}>

        {/* <ScrollView style={{backgroundColor:'white', flexDirection:'column', position:'absolute', bottom:0, left:0, right:0, width:'100%', height:200}}> */}
        {/* <Text  ref={node => { Utilities.oTxt = node; }}  style={{color:'black', width:100}}>{Utilities.sTxt}</Text> */}
        {/* </ScrollView> */}

          <Sample_Login/>
          <ModalEx ref={node => { oModalEx = node; }}/>

          {/* <TouchableOpacity
          style={[styles.button_logout, {position:'absolute', left:10, top:30, zIndex:200, backgroundColor: 'orange'}]}
          onPress={ShowPopup}
          >
 
          <FontAwesome style={{ marginBottom: 0 }} name="bars" size={16} color="white" />
        </TouchableOpacity>   */}

          <Sample_Topbar/>
          {/* <Sample_Reorder/> */}
          {/* <Order bindEvent={this.props.bindEvent} onSelectAccount={this.props.onSelectAccount} oData={this.props.oData} ref={node => { this.oOrderRef = node; }} /> */}
          <ReOrderEx bindEvent={BindEvent} ref={node => { oReOrderEx = node; }}/>
          {/* <Sample_Symbols/> */}

          {/* <Sample_SymbolSearch/> */}
          <Search ref={node => { oSearch = node; }}/>
          <About ref={node => { oAbout = node; }}/>

          <SymbolList ref={node => { oSymList = node; }} removeSymbol={RemoveSymbol} /*setTxtSearch={SetTextSearch}*/ bindEvent={BindEvent}/>
          {/* <Sample_Searchbar/> */}
          {/* <Sample_Bottombar/> */}
          <MessageRates bindEvent={BindEvent} color={oThemes[i_theme]?.color} />

        </SafeAreaView>

      </ImageBackground>
    </View>
   </KeyboardAvoidingView>
  );
}


//⇅
//🔋
//width:'32%'
//width:'36%',
//width:'32%'
//{transform: [{scale: .5}]}
//"  ●"
/*" • "*/
//◮ ⑆

/*   =====================================================================   */

const styles = StyleSheet.create({

  container_sort_cover: {
    backgroundColor: 'transparent',
    alignSelf:'center',
    width:200,
  },

  container_sort: {
    backgroundColor: 'transparent',
    alignSelf:'center',
  },

  tile_sort: {
    backgroundColor:'transparent',
    width: '100%',
    height: '100%',
  },

  container:
  {
  flex: 1,
  margin: 0,
  },

container2:
  {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start',
  backgroundColor: "transparent",
  margin: 30,
  },

container_header:
  {
  alignItems: 'center',
  justifyContent: 'center',
  margin: 0,
  height:50,
  borderBottomWidth:0,
  borderBottomColor:'#4b5f6d',
  },

container_header2:
  {
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexDirection: 'row',
  height:50,
  borderBottomWidth:0,
  borderBottomColor:'#4b5f6d',
  },

sym_container:
  {
  alignItems: 'flex-start',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: "center",//"space-between",
  backgroundColor: "transparent",
  padding: 0,
  margin: 0,
  },

row_version: 
  {
  alignSelf:'center',
  color: 'grey',
  },

row_header: 
  {
  alignSelf: 'center',
  //fontSize: FontInfo.iFontSize + 4,
  alignItems: 'center',
  justifyContent: 'center',
  //fontWeight: 'bold',
  color: 'white',
  },

login_container: 
  {
  width: Utilities.WIDTH,
  //height: 350,
  paddingTop:4,
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  //backgroundColor: FontInfo.sBackground,//'white',
  //borderColor:'white',
  //borderWidth: 1,
  borderBottomRightRadius:20,
  borderBottomLeftRadius:20,
  },

login_header: 
  {
  zIndex:1,
  shadowColor:'black',
  shadowOffset:{width:0, height:6},
  shadowOpacity:0,
  shadowRadius:6,
  width: Utilities.WIDTH,
  height: 36,
  paddingTop:4,
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0,0,0,255)',
  borderColor:'rgba(0,0,0,255)',
  borderWidth: 1,
  borderTopRightRadius:20,
  borderTopLeftRadius:20,
  },

button: 
  {
  width:Utilities.WIDTH * 0.714,
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop:28,
  paddingVertical: 12,
  paddingHorizontal: 28,
  borderRadius: 20,
  elevation: 3,
  backgroundColor: '#04cd25', //'#00FA9A', /* mediumspringgreen' //*20fe2b*/
  },

button_logout: 
  {
  width:40,
  height:40,
  marginTop:2,
  alignSelf:'flex-end',

  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 20,
  },

  button_plus_top: 
  {
  width:40,
  height:40,
  marginRight:6,
  alignSelf:'flex-end',

  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 20,
  backgroundColor: 'cornflowerblue',// '#04cd25',
  },

  button_plus: 
  {
  width:70,
  height:70,
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 35,
  backgroundColor: 'cornflowerblue',
  padding:20,
  margin:10,
  },

login_input: 
  {
  alignSelf:'center',
  //fontSize:FontInfo.iFontSize + 4,
  width:Utilities.WIDTH - 50,
  height: 44,
  margin: 4,
  borderWidth: 0,
  padding: 10,
  paddingLeft:11,
  //borderColor:'white',
  borderBottomWidth:1,
  //borderBottomColor:FontInfo.sDivider,
  backgroundColor:'transparent',//'white',
  //color:FontInfo.sForeground,
  },

login_input_invalid: 
  {
  alignSelf:'center',
  //fontSize: FontInfo.iFontSize + 4,
  width:Utilities.WIDTH - 50,
  height: 44,
  margin: 4,
  borderWidth: 0,
  padding: 10,
  paddingLeft:11,
  borderColor:'white',
  borderBottomWidth:1,
  //borderBottomColor:'red',
  backgroundColor:'transparent',//'#ffe4e1',
  color:'red', //'black',
  },

  search_input: 
  {
  alignSelf:'center',
  //fontSize: FontInfo.iFontSize + 4,
  height: 44,
  width:260,
  borderWidth: 0,
  margin:4,
  padding:10,
  paddingLeft:4,
  borderColor:'white',
  borderBottomWidth:1,
  //borderBottomColor:FontInfo.sDivider,//'#EEEEEE',
  //backgroundColor:'transparent',
  //color:FontInfo.sForeground,
  },

  search_input_invalid: 
  {
  alignSelf:'center',
  //fontSize: FontInfo.iFontSize + 4,
  height: 44,
  borderWidth: 0,
  margin:4,
  padding:10,
  paddingLeft:4,
  width:260,
  //borderColor:'white',
  borderBottomWidth:1,
  borderBottomColor:'red',
  //backgroundColor:'transparent',//'#ffe4e1',
  //color:FontInfo.sForeground,
  },

text: 
  {
  //fontSize: FontInfo.iFontSize + 4,
  fontWeight: 'bold',
  letterSpacing: 0.25,
  color: 'white',
  },

});

function GetPickerStyles()
{
return(

  StyleSheet.create({
    inputWeb: {

      fontFamily: FontInfo.iFont > 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 4,
      paddingVertical: 12,
      paddingHorizontal: 5,
  
      marginLeft:5,
      width:Utilities.WIDTH - 50,
      marginTop:5,
  
      borderWidth: 0,
      borderColor: 'gray',
      borderRadius: 4,
      borderBottomWidth:1,
      borderBottomColor:FontInfo.sDivider,
      borderBottomEndRadius:0,
      borderBottomStartRadius:0,
  
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    inputIOS: {
      fontFamily: FontInfo.iFont > 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 4,
      paddingVertical: 12,
      paddingHorizontal: 10,
  
      marginTop:10,
      marginLeft:5,
      width:Utilities.WIDTH - 50,
  
      borderWidth: 0,
      borderBottomWidth:1,
      borderBottomColor:FontInfo.sDivider,
      borderBottomEndRadius:0,
      borderBottomStartRadius:0,
  
      //color: 'black',
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    inputAndroid: {
      fontFamily: FontInfo.iFont > 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      // alignSelf:'center',
      fontSize: FontInfo.iFontSize + 4,
      fontWeight:'normal',
      // paddingLeft: 20,
      paddingVertical: 12,
      paddingHorizontal: 10,
  
      marginTop:0,
      marginLeft:5,
      width:Utilities.WIDTH - 50,
  
      borderWidth: 0,
      borderBottomWidth:1,
      borderBottomColor:FontInfo.sDivider,
      borderBottomEndRadius:0,
      borderBottomStartRadius:0,
      // textAlign:'center',
      // borderWidth: 0.5,
      // borderColor: 'purple',
      // borderRadius: 8,
      //color: 'black',
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
  })
);  
}

// const pickerSelectStyles = StyleSheet.create({
//   inputWeb: {
//     fontFamily: FontInfo.iFont > 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
//     fontSize: FontInfo.iFontSize + 4,
//     paddingVertical: 12,
//     paddingHorizontal: 5,

//     marginLeft:5,
//     width:Utilities.WIDTH - 50,
//     marginTop:5,

//     borderWidth: 0,
//     borderColor: 'gray',
//     borderRadius: 4,
//     borderBottomWidth:1,
//     borderBottomColor:'#EEEEEE',
//     borderBottomEndRadius:0,
//     borderBottomStartRadius:0,


//     backgroundColor:'white',
//     color: 'black',
//     paddingRight: 30, // to ensure the text is never behind the icon
//   },

//   inputIOS: {
//     fontFamily: FontInfo.iFont > 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
//     fontSize: FontInfo.iFontSize + 4,
//     paddingVertical: 12,
//     paddingHorizontal: 10,

//     marginTop:10,
//     marginLeft:5,
//     width:Utilities.WIDTH - 50,

//     borderWidth: 0,
//     borderBottomWidth:1,
//     borderBottomColor:'#EEEEEE',
//     borderBottomEndRadius:0,
//     borderBottomStartRadius:0,

//     color: 'black',
//     paddingRight: 30, // to ensure the text is never behind the icon
//   },

//   inputAndroid: {
//     fontFamily: FontInfo.iFont > 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
//     // alignSelf:'center',
//     fontSize: FontInfo.iFontSize + 4,
//     fontWeight:'normal',
//     // paddingLeft: 20,
//     paddingVertical: 12,
//     paddingHorizontal: 10,

//     marginTop:0,
//     marginLeft:5,
//     width:Utilities.WIDTH - 50,

//     borderWidth: 0,
//     borderBottomWidth:1,
//     borderBottomColor:'#EEEEEE',
//     borderBottomEndRadius:0,
//     borderBottomStartRadius:0,
//     // textAlign:'center',
//     // borderWidth: 0.5,
//     // borderColor: 'purple',
//     // borderRadius: 8,
//     color: 'black',
//     paddingRight: 30, // to ensure the text is never behind the icon
//   },
// });